import React from 'react';
import categories from '../../data/categories.json';
import provinces from '../../data/provinces.json';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer_above">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="footer_widget footer_widget_padding">
                                <img src="/images/logo-white.png" width={"100px"} alt="RB Costruzioni Srl" />
                                <h4 className="widget_title">
                                    RB Costruzioni Srl
                                </h4>
                                <p>Costruzioni civili e industriali</p>
                                <div className="footer_widget">
                                <ul>
                                    <li><i className="fa fa-map-marker" aria-hidden="true"></i><span>Via Tagliamento 24 Mirandola (MO)</span></li>
                                    <li><i className="fa fa-envelope" aria-hidden="true"></i><span>preventivirb@gmail.com</span></li>
                                    <li><i className="fa fa-clock-o" aria-hidden="true"></i><span>Lunedi - Sabato (8.00 - 18.00)</span></li>
                                </ul>
                                {/* <div className="side_footer_social">
                                    <ul className="bottom_social">
                                        <li className="facebook"><a href="#"><i className="ion-social-facebook"></i></a></li>
                                        <li className="twitter"><a href="#"><i className="ion-social-twitter"></i></a></li>
                                        <li className="dribbble"><a href="#"><i className="ion-social-dribbble-outline"></i></a></li>
                                        <li className="instagram"><a href="#"><i className="ion-social-instagram-outline"></i></a></li>
                                        <li className="linkedin"><a href="#"><i className="ion-social-linkedin-outline"></i></a></li>
                                    </ul>
                                </div> */}
                            </div>
        
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-6 col-sm-12">
                            <div className="footer_widget footer_links">
                                <h4 className="widget_title">
                                    I nostri servizi
                                </h4>
                                <div className="footer_nav">
                                    <ul className="footer_menu">
                                        {Object.entries(categories).map(([key, value]) => (
                                            <li className="menu-item"><a href={`/${key}`}>{value}</a></li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-6 col-sm-12">
                            <div className="footer_widget footer_links">
                                <h4 className="widget_title">
                                   Province coperte
                                </h4>
                                <div className="footer_nav">
                                    <ul className="footer_menu">
                                        {provinces.slice(0, Math.ceil(provinces.length / 2)).map((province) => (
                                           <li className="menu-item">{province}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-6 col-sm-12">
                            <div className="footer_widget footer_links">
                                <h4 className="widget_title">
                                   
                                </h4>
                                <div className="footer_nav">
                                    <ul className="footer_menu">
                                        {provinces.slice(Math.ceil(provinces.length / 2)).map((province) => (
                                           <li className="menu-item">{province}</li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer_bottom">
                <div className="container">
                    <div className="footer_bottom_inner">
                        
                        <div className="copyright">
                            <p>&copy;2024 RB Costruzioni Srl. Tutti i diritti riservati.</p>
                        </div>
                        <div className="footer_nav_bottom">
                            <ul>
                                <li><a href="#">Condizioni d'uso</a></li>
                                <li><a href="#">Informativa sulla privacy</a></li>
                            </ul>
                        </div>
                        <div className="totop">
                            <a href="#"><i className="ion-ios-arrow-up"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;